import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { StudentNoteService } from "@/services/api/student-note";
import { useQuery } from "@tanstack/react-query";
import { Loader2Icon, PlusIcon } from "lucide-react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import ModalAddStudentNote from "./modal-add-student-note";
import StudentNotesList from "./student-notes-list";

export default function StudentNotesCard() {
  const { id } = useParams();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["student_notes", id],
    enabled: Boolean(id),
    refetchOnWindowFocus: false,
    queryFn: () => StudentNoteService.getAll(id as string),
  });

  return (
    <>
      <Card className="bg-gray-800 mt-10">
        <CardHeader>
          <CardTitle className="flex text-gray-200 items-center justify-between">
            Anotações
            {isLoading ? (
              <Loader2Icon className="h-4 w-4 animate-spin" />
            ) : (
              <Button
                size="default"
                variant="outline"
                className="bg-transparent"
                onClick={() => setIsAddModalOpen(true)}
              >
                <PlusIcon size={18} className="mr-2" />
                Nova anotação
              </Button>
            )}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <StudentNotesList
            studentId={id as string}
            notes={data}
            isLoading={isLoading}
            onDeleted={() => refetch()}
          />
        </CardContent>
      </Card>

      {id ? (
        <ModalAddStudentNote
          studentId={id}
          isOpen={isAddModalOpen}
          onClose={() => setIsAddModalOpen(false)}
          onSuccess={() => refetch()}
        />
      ) : null}
    </>
  );
}
